<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <!--            <v-btn to="/tickets" rounded color="#A5668B" class="text-white">-->
            <!--              <v-icon>mdi-backspace-reverse-outline</v-icon>-->
            <!--              بازگشت-->
            <!--            </v-btn>-->
            <v-card class="m-20" :loading="loading">
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->

                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->

                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg12 xl12 class="p-2">
                    <v-text-field
                      :error-messages="
                        errors !== undefined ? errors.title : null
                      "
                      v-model="title"
                      label="عنوان تیکت"
                      required
                      outlined
                    ></v-text-field>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg12 xl12 class="p-2">
                    <v-select
                      v-model="service"
                      :items="services"
                      :error-messages="
                        errors !== undefined ? errors.service_id : null
                      "
                      item-text="nameFa"
                      item-value="id"
                      label="انتخاب سرویس"
                      outlined
                    ></v-select>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="selectedDepartment"
                      :items="departments"
                      item-text="title"
                      v-on:change="notifyStatus"
                      item-value="id"
                      outlined
                      label="دپارتمان"
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <!--  <p>اولویت بندی</p>-->

                    <v-btn-toggle
                      class="mr-8"
                      v-model="importance"
                      shaped
                      mandatory
                    >
                      <v-btn value="3" color="success"> معمولی </v-btn>

                      <v-btn value="2" color="warning"> مهم </v-btn>

                      <v-btn value="1" color="error"> بسیار مهم </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="notify">
                    <!--                    <ckeditor v-if="ckEditor"-->
                    <!--                              :editor="editor.editor" v-model="text" :config="editor.editorConfig"></ckeditor>-->
                  </v-flex>
                  <v-textarea
                    v-model="text"
                    dense
                    outlined
                    label="متن پیام"
                    :error-messages="
                      errors !== undefined ? errors.description : null
                    "
                  ></v-textarea>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6>
                    <v-file-input
                      v-model="attach"
                      label="پیوست فایل"
                      outlined
                    ></v-file-input>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-btn
                      @click="addTicket"
                      :loading="loading"
                      color="#50858B"
                      class="text-white p-6 ml-30"
                    >
                      <v-icon class="ml-4">mdi-send</v-icon>
                      ارسال تیکت
                    </v-btn>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import PermissionPicker from "@/view/pages/pickers/permissionPicker";
import userPicker from "@/view/pages/pickers/userPicker";

export default {
  components: { PermissionPicker, userPicker },
  data() {
    return {
      loading: false,
      title: "",
      notify: false,
      text: "",
      attach: null,
      ckEditor: false,
      errors: [],
      importance: "",
      departments: [],
      selectedDepartment: null,
      service: null,
      services: [],
      textArea: true,
      notify_type: "sms",
      status_types: [
        { name: "info", value: "اطلاع رسانی" },
        { name: "success", value: "موفقیت" },
        { name: "warning", value: "هشدار" },
        { name: "danger", value: "خطر" },
      ],
      notify_types: [
        { name: "sms", value: "پیامک" },
        { name: "email", value: "ایمیل" },
        { name: "notification", value: "اطلاع رسانی" },
        { name: "push_notification", value: "اطلاع رسانی پنل" },
      ],
      cost: "",
      users: [],
      extras: {
        notify_at: "",
        status_type: "",
        icon: "",
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
    };
  },
  created() {
    let serviceJson = this.getServiceTicket().data;

    this.services = serviceJson.filter((value) => {
      return this.can(value.userGate);
    });

    this.getDepartments();
  },
  methods: {
    addTicket() {
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("department_id", this.selectedDepartment);
      formData.append("importance", this.importance);
      formData.append("description", this.text);
      if (this.service != null) formData.append("service_id", this.service);
      if (this.attach != null) formData.append("attach", this.attach);

      this.loading = true;
      this.requestApiPost("ticket", formData, this.configurationFile())
        .then((response) => {
          this.loading = false;
          this.$toast.success("تیکت با موفقیت ارسال شد.");
          this.$router.push({ name: "tickets.index" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        });
    },

    getDepartments() {
      this.requestApiGet("department").then((response) => {
        this.departments = response.data.data;
      });
    },

    notifyStatus(data) {
      if (data.name === "sms") {
        this.ckEditor = false;
        this.textArea = true;
        this.notify = false;
      } else {
        this.notify = true;
        this.textArea = false;
        this.ckEditor = true;
        this.cost = "";
      }
    },
  },
};
</script>
